import { z } from 'zod';

/** Package-owned GPU residency and scoring policy; graph order still governs input execution. */
export const macroMatchingModeSchema = z.enum(['sequential', 'concurrent']);
export type MacroMatchingMode = z.infer<typeof macroMatchingModeSchema>;
/** An absent field retains the graph-frontier behavior of previously saved packages. */
export const DEFAULT_MACRO_MATCHING_MODE: MacroMatchingMode = 'sequential';

/** Product-facing GPU residency choice. It never changes graph traversal order. */
export const macroReferenceLoadingModeSchema = z.enum(['resident', 'streamed']);
export type MacroReferenceLoadingMode = z.infer<typeof macroReferenceLoadingModeSchema>;
export const DEFAULT_MACRO_REFERENCE_LOADING_MODE: MacroReferenceLoadingMode = 'streamed';

export function referenceLoadingModeForMatchingMode(
  matchingMode: MacroMatchingMode | undefined,
): MacroReferenceLoadingMode {
  return (matchingMode ?? DEFAULT_MACRO_MATCHING_MODE) === 'concurrent' ? 'resident' : 'streamed';
}

export function matchingModeForReferenceLoadingMode(
  loadingMode: MacroReferenceLoadingMode,
): MacroMatchingMode {
  return loadingMode === 'resident' ? 'concurrent' : 'sequential';
}
